'use strict';

/**
 * Overview for the sets
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var BaseLayout = require('modules/collection/views/layout/base');
var ListControlView = require('../partials/list-control');
var SetsHeaderView = require('./sets-header');
var SetsListView = require('../partials/sets-list');
var DropControlView = require('modules/collection/views/partials/drop-control');

var template = require('modules/collection/modules/set/templates/layout/sets-list.hbs');

var SetsListLayout = BaseLayout.extend({
    template: template,

    viewData: {
        count: function() {
            return this.collection.length;
        },
    },

    regions: {
        listRegion: '.sets-list-region',
        controlsRegion: '.listcontrol-region',
        headerRegion: '.header-region',
        dropControlRegion: '.drop-control-region',
    },

    ui: {
        'setCount': '.set-count',
    },

    collectionEvents: {
        'add remove reset sync': 'updateView',
    },

    initialize: function(options) {
        BaseLayout.prototype.initialize.apply(this, arguments);
    },

    updateView: function() {
        this.ui.setCount.html(App.t('collection::sets:count', this.collection.length));
    },

    onBeforeShow: function () {
        var viewOptions = {
            catalog: this.collection.catalog,
            collection: this.collection,
            model: this.model,
            moduleParams: this.getOption('moduleParams'),
        };
        this.controlsRegion.show(new ListControlView(viewOptions));
        this.headerRegion.show(new SetsHeaderView(viewOptions));
        this.listRegion.show(new SetsListView(viewOptions));
        this.dropControlRegion.show(new DropControlView(viewOptions));
    },
});

module.exports = SetsListLayout;